import { Client } from '../types/entities'

export const mockClients: Client[] = [
  {
    id: 'c1',
    name: 'RTGuard Segurança',
    email: 'contato@rtguard.com.br',
    phone: '(31) 98765-4321',
    cnpj: '12.345.678/0001-90',
    city: 'Belo Horizonte',
    state: 'MG',
    createdAt: '2023-03-15',
  },
  {
    id: 'c2',
    name: 'Supermercados Alfa',
    email: 'ti@supermercadosalfa.com.br',
    phone: '(31) 3333-4444',
    cnpj: '98.765.432/0001-10',
    city: 'Contagem',
    state: 'MG',
    createdAt: '2023-07-01',
  },
  {
    id: 'c3',
    name: 'Clínica VidaSaúde',
    email: 'admin@vidasaude.com.br',
    phone: '(11) 91234-5678',
    cnpj: '11.222.333/0001-44',
    city: 'São Paulo',
    state: 'SP',
    createdAt: '2024-01-10',
  },
  {
    id: 'c4',
    name: 'Construtora Alvorada',
    email: 'contato@alvorada.eng.br',
    phone: '(31) 97654-3210',
    city: 'Belo Horizonte',
    state: 'MG',
    createdAt: '2024-04-22',
  },
  {
    id: 'c5',
    name: 'Logística FastMove',
    email: 'ops@fastmove.com.br',
    phone: '(21) 99988-7766',
    cnpj: '55.666.777/0001-88',
    city: 'Rio de Janeiro',
    state: 'RJ',
    createdAt: '2024-09-05',
  },
]
